import {
    ComponentFactoryResolver,
    Directive,
    Input,
    OnInit,
    ViewContainerRef
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../components/dynamic-form/dynamic-form-config.interface';
import { InputComponent } from '../../components/input/input.component';
// import { SelectComponent } from '../select/select.component';
import { DateInputComponent } from '../../components/date-input/date-input.component';
// import { RadiobuttonComponent } from '../radiobutton/radiobutton.component';
import { CheckboxComponent } from '../../components/checkbox/checkbox.component';
import { SelectComponent } from '../../components/select/select.component';
import { BooleanSelectionComponent } from '../../components/boolean-selection/boolean-selection.component';
import { AutocompleteComponent } from '../../components/autocomplete/autocomplete.component';

const componentMapper = {
    input: InputComponent,
    date: DateInputComponent,
    checkbox: CheckboxComponent,
    select: SelectComponent,
    booleanSelect: BooleanSelectionComponent,
    autocomplete: AutocompleteComponent
};
@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[dynamicField]'
})
export class DynamicFieldDirective implements OnInit {
    _field: FieldConfig;
    @Input()
    set field(field: FieldConfig) {
        this._field = field;
    }
    get field() { return this._field; }
    _group: FormGroup;
    @Input()
    set group(group: FormGroup) {
        this._group = group;
    }
    get group() { return this._group; }

    componentRef: any;

    constructor(
        private resolver: ComponentFactoryResolver,
        private container: ViewContainerRef,
    ) { }

    ngOnInit(): void {
        const factory = this.resolver.resolveComponentFactory<any>(
            componentMapper[this.field.type]
        );
        this.componentRef = this.container.createComponent(factory);
        this.componentRef.instance.field = this._field;
        this.componentRef.instance.group = this._group;
    }
}
